(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["garden-buildings-cro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-cvgf-building]');
  if (!root) return;
  const mainImage = root.querySelector('#CvgfBuildingMainImage');
  const galleryLightbox = root.querySelector('[data-gallery-lightbox]');
  const lightboxImage = root.querySelector('[data-lightbox-image]');
  const lightboxCaption = root.querySelector('[data-lightbox-caption]');
  const galleryJson = root.querySelector('[data-gallery-images]');
  const galleryImages = galleryJson ? JSON.parse(galleryJson.textContent || '[]') : [];
  let lightboxIndex = 0;
  const price = root.querySelector('[data-main-price]');
  const compare = root.querySelector('[data-compare-price]');
  const salePill = root.querySelector('[data-sale-pill]');
  const variantInput = root.querySelector('[data-variant-input]');
  const enquirySize = root.querySelector('[data-enquiry-size]');
  const mobileSize = root.querySelector('[data-mobile-size]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const buyCard = root.querySelector('.cvgf-buy-card');
  const dialog = root.querySelector('[data-enquiry-dialog]');

  const optionSelects = Array.from(root.querySelectorAll('[data-option-select]')).sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0));
  const variantJson = root.querySelector('[data-variant-json]');
  const variants = variantJson ? JSON.parse(variantJson.textContent || '[]') : [];
  const addButton = root.querySelector('[data-add-button]');
  const productForm = root.querySelector('#GardenBuildingProductForm');
  const quoteUpgradeSelects = Array.from(root.querySelectorAll('[data-quote-upgrade]'));
  const enquiryUpgrades = root.querySelector('[data-enquiry-upgrades]');
  const enquiryBody = root.querySelector('textarea[name="contact[body]"]');
  const combinedVariantSelect = root.querySelector('[data-combined-variant-select]');
  const combinedRoof = root.querySelector('[data-combined-roof]');
  const combinedMembrane = root.querySelector('[data-combined-membrane]');
  const doorCombinedSelect = root.querySelector('[data-door-combined-select]');
  const doorStyleControl = root.querySelector('[data-door-style-control]');
  const doorLockControl = root.querySelector('[data-door-lock-control]');
  const currency = root.dataset.currency || 'GBP';
  const addLabel = root.dataset.addLabel || 'Add to basket';
  const soldOutLabel = root.dataset.soldoutLabel || 'Sold out';
  const quoteLabel = root.dataset.quoteLabel || 'Get upgrade price';
  const quoteIntro = root.dataset.quoteIntro || 'Please price the following building upgrades:';
  const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents || 0) / 100);

  const quoteUpgradeSummary = () => quoteUpgradeSelects
    .filter((select) => select.selectedOptions[0]?.dataset.requiresQuote === 'true')
    .map((select) => `${select.dataset.upgradeLabel}: ${select.options[select.selectedIndex]?.text || select.value}`);

  const requiresUpgradeQuote = () => quoteUpgradeSummary().length > 0;

  const selectedOptions = () => optionSelects.map((select) => select.value);

  const findVariant = () => {
    if (!variants.length) return null;
    if (!optionSelects.length) {
      return variants.find((variant) => String(variant.id) === String(variantInput?.value || '')) || variants[0];
    }
    const selected = selectedOptions();
    return variants.find((variant) => Array.isArray(variant.options) && variant.options.length === selected.length && variant.options.every((value, index) => value === selected[index]));
  };

  const refreshOptionAvailability = () => {
    const selected = selectedOptions();
    optionSelects.forEach((select, selectIndex) => {
      Array.from(select.options).forEach((option) => {
        const candidate = [...selected];
        candidate[selectIndex] = option.value;
        const exists = variants.some((variant) => variant.available && variant.options.every((value, index) => value === candidate[index]));
        option.disabled = !exists && option.value !== select.value;
      });
    });
  };

  const applyVariant = (variant) => {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = money(variant.price);
    if (mobilePrice) mobilePrice.textContent = money(variant.price);
    if (mobileSize) mobileSize.textContent = variant.title;
    if (enquirySize) enquirySize.value = variant.title;
    const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
    if (compare) {
      compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
      compare.classList.toggle('is-hidden', !hasCompare);
    }
    if (salePill) {
      const saving = hasCompare ? Number(variant.compare_at_price) - Number(variant.price) : 0;
      salePill.textContent = saving > 0 ? `Save ${money(saving)}` : '';
      salePill.classList.toggle('is-hidden', saving <= 0);
    }
    if (addButton) {
      if (requiresUpgradeQuote()) {
        addButton.disabled = false;
        addButton.textContent = quoteLabel;
      } else {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addLabel : soldOutLabel;
      }
    }
  };

  const setCombinedPackage = (upgrade) => {
    if (!combinedVariantSelect) return;
    const target = Array.from(combinedVariantSelect.options).find((option) => {
      const value = option.value.toLowerCase();
      if (upgrade) return value.includes('rubber') || (value.includes('yes') && !value.includes('no'));
      return value.includes('felt') || value.includes('standard') || value.startsWith('no');
    });
    if (!target) return;
    combinedVariantSelect.value = target.value;
    if (combinedRoof) combinedRoof.value = upgrade ? 'epdm' : 'felt';
    if (combinedMembrane) combinedMembrane.value = upgrade ? 'yes' : 'no';
    refreshOptionAvailability();
    applyVariant(findVariant());
  };

  const syncCombinedVisible = () => {
    if (!combinedVariantSelect) return;
    const value = combinedVariantSelect.value.toLowerCase();
    const upgrade = value.includes('rubber') || (value.includes('yes') && !value.includes('no'));
    if (combinedRoof) combinedRoof.value = upgrade ? 'epdm' : 'felt';
    if (combinedMembrane) combinedMembrane.value = upgrade ? 'yes' : 'no';
  };

  const syncDoorVisible = () => {
    if (!doorCombinedSelect) return;
    const value = doorCombinedSelect.value.toLowerCase();
    if (doorStyleControl) doorStyleControl.value = value.includes('double') ? 'double' : 'single';
    if (doorLockControl) doorLockControl.value = value.includes('key') ? 'key' : 'hasp';
  };

  const setDoorVariant = () => {
    if (!doorCombinedSelect) return;
    const style = doorStyleControl?.value || 'single';
    const lock = doorLockControl?.value || 'hasp';
    const target = Array.from(doorCombinedSelect.options).find((option) => {
      const value = option.value.toLowerCase();
      const styleMatches = style === 'double' ? value.includes('double') : value.includes('single');
      const lockMatches = lock === 'key' ? value.includes('key') : value.includes('hasp');
      return styleMatches && lockMatches;
    });
    if (!target) return;
    doorCombinedSelect.value = target.value;
    refreshOptionAvailability();
    applyVariant(findVariant());
  };

  optionSelects.forEach((select) => {
    select.addEventListener('change', () => {
      refreshOptionAvailability();
      applyVariant(findVariant());
      syncCombinedVisible();
      syncDoorVisible();
    });
  });

  combinedRoof?.addEventListener('change', () => setCombinedPackage(combinedRoof.value === 'epdm'));
  combinedMembrane?.addEventListener('change', () => setCombinedPackage(combinedMembrane.value === 'yes'));
  doorStyleControl?.addEventListener('change', setDoorVariant);
  doorLockControl?.addEventListener('change', setDoorVariant);

  quoteUpgradeSelects.forEach((select) => {
    select.addEventListener('change', () => applyVariant(findVariant()));
  });

  productForm?.addEventListener('submit', (event) => {
    if (!requiresUpgradeQuote()) return;
    event.preventDefault();
    const summary = quoteUpgradeSummary();
    if (enquiryUpgrades) enquiryUpgrades.value = summary.join(' | ');
    if (enquiryBody) enquiryBody.value = `${quoteIntro}\n${summary.join('\n')}`;
    if (dialog?.showModal) dialog.showModal();
  });

  root.querySelectorAll('[data-option-help]').forEach((button) => {
    button.addEventListener('click', () => {
      const panelId = button.getAttribute('aria-controls');
      const panel = panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
      if (!panel) return;
      const opening = panel.hidden;
      root.querySelectorAll('[data-option-help]').forEach((otherButton) => {
        const otherId = otherButton.getAttribute('aria-controls');
        const otherPanel = otherId ? root.querySelector(`#${CSS.escape(otherId)}`) : null;
        if (otherPanel && otherPanel !== panel) {
          otherPanel.hidden = true;
          otherButton.setAttribute('aria-expanded', 'false');
        }
      });
      panel.hidden = !opening;
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
  });

  syncCombinedVisible();
  syncDoorVisible();
  refreshOptionAvailability();
  applyVariant(findVariant());

  const showLightboxImage = (index) => {
    if (!galleryImages.length || !lightboxImage) return;
    lightboxIndex = (index + galleryImages.length) % galleryImages.length;
    const item = galleryImages[lightboxIndex];
    lightboxImage.src = item.url;
    lightboxImage.alt = item.alt || '';
    if (lightboxCaption) lightboxCaption.textContent = item.alt || '';
  };

  const findGalleryIndexByUrl = (url) => {
    if (!url || !galleryImages.length) return 0;
    const source = String(url).split('?')[0];
    const filename = source.split('/').pop();
    const found = galleryImages.findIndex((item) => {
      const candidate = String(item.url || '').split('?')[0];
      return candidate === source || candidate.endsWith('/' + filename);
    });
    return found >= 0 ? found : 0;
  };

  const openLightbox = (index) => {
    if (!galleryLightbox?.showModal || !galleryImages.length) return;
    showLightboxImage(index);
    galleryLightbox.showModal();
  };

  root.querySelector('[data-gallery-open]')?.addEventListener('click', () => {
    openLightbox(findGalleryIndexByUrl(mainImage?.src));
  });

  root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => galleryLightbox?.close());
  root.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => showLightboxImage(lightboxIndex - 1));
  root.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showLightboxImage(lightboxIndex + 1));

  galleryLightbox?.addEventListener('click', (event) => {
    if (event.target === galleryLightbox) galleryLightbox.close();
  });

  galleryLightbox?.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showLightboxImage(lightboxIndex - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showLightboxImage(lightboxIndex + 1);
    }
  });

  root.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!mainImage || !button.dataset.imageUrl) return;
      mainImage.style.opacity = '0.35';
      window.setTimeout(() => {
        // Responsive sources otherwise keep showing the old image even after src changes.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = button.dataset.imageUrl;
        mainImage.alt = button.dataset.imageAlt || '';
        mainImage.style.opacity = '1';
      }, 120);
      root.querySelectorAll('.cvgf-thumb').forEach((thumb) => thumb.classList.remove('is-active'));
      if (button.classList.contains('cvgf-thumb')) button.classList.add('is-active');
      if (!button.classList.contains('cvgf-thumb')) {
        openLightbox(findGalleryIndexByUrl(button.dataset.imageUrl));
      }
    });
  });

  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    const input = root.querySelector('#GardenBuildingQuantity');
    if (!input) return;
    input.value = Math.max(1, Number(input.value || 1) - 1);
  });

  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    const input = root.querySelector('#GardenBuildingQuantity');
    if (!input) return;
    input.value = Math.max(1, Number(input.value || 1) + 1);
  });

  root.querySelectorAll('[data-scroll-buy]').forEach((button) => {
    button.addEventListener('click', () => buyCard?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  });

  root.querySelectorAll('[data-enquiry-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (dialog?.showModal) dialog.showModal();
    });
  });

  root.querySelector('[data-enquiry-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  const reviewTeaser = root.querySelector('[data-review-teaser]');
  const reviewCards = root.querySelector('[data-review-cards]');
  const fullReviews = root.querySelector('[data-full-reviews]');
  const reviewScroll = root.querySelector('[data-review-scroll]');
  const topReviewBadge = root.querySelector('.cvgf-review-badge');
  const verifiedLabel = root.dataset.reviewVerifiedLabel || '';
  const ratingSuffix = root.dataset.reviewRatingSuffix || '';

  const buildReviewTeaser = () => {
    if (!reviewTeaser || !reviewCards || !fullReviews) return false;
    const reviewNodes = Array.from(fullReviews.querySelectorAll('.jdgm-rev'))
      .filter((review) => review.querySelector('.jdgm-rev__body')?.textContent?.trim())
      .slice(0, 3);

    if (!reviewNodes.length) return false;

    reviewCards.replaceChildren();

    reviewNodes.forEach((review) => {
      const body = review.querySelector('.jdgm-rev__body')?.textContent?.trim() || '';
      const title = review.querySelector('.jdgm-rev__title')?.textContent?.trim() || '';
      const author = review.querySelector('.jdgm-rev__author')?.textContent?.trim() || '';
      const ratingElement = review.querySelector('.jdgm-rev__rating');
      const ratingFromData = Number(ratingElement?.getAttribute('data-score') || '');
      const ratingLabel = ratingElement?.getAttribute('aria-label') || '';
      const ratingMatch = ratingLabel.match(/([0-5](?:\.[0-9])?)/);
      const rating = Number.isFinite(ratingFromData) && ratingFromData > 0
        ? ratingFromData
        : ratingMatch
          ? Number(ratingMatch[1])
          : null;
      const verified = Boolean(review.querySelector('.jdgm-rev__buyer-badge'));

      const card = document.createElement('article');
      card.className = 'cvgf-review-card';

      if (rating !== null) {
        const roundedRating = Math.max(0, Math.min(5, Math.round(rating)));
        const stars = document.createElement('div');
        stars.className = 'cvgf-review-stars';
        stars.setAttribute('aria-label', `${rating.toFixed(1)} ${ratingSuffix}`.trim());
        stars.textContent = `${'★'.repeat(roundedRating)}${'☆'.repeat(5 - roundedRating)}`;
        card.appendChild(stars);
      }

      if (title) {
        const heading = document.createElement('h3');
        heading.className = 'cvgf-review-title';
        heading.textContent = title;
        card.appendChild(heading);
      }

      const copy = document.createElement('p');
      copy.className = 'cvgf-review-text';
      copy.textContent = `“${body}”`;
      card.appendChild(copy);

      if (author || verified) {
        const meta = document.createElement('p');
        meta.className = 'cvgf-review-meta';
        meta.textContent = author && verified
          ? `${author} · ${verifiedLabel}`
          : author || verifiedLabel;
        card.appendChild(meta);
      }

      reviewCards.appendChild(card);
    });

    reviewTeaser.hidden = false;
    return true;
  };

  const scrollToReviews = () => {
    fullReviews?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  reviewScroll?.addEventListener('click', scrollToReviews);

  if (topReviewBadge) {
    topReviewBadge.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToReviews();
    });
    topReviewBadge.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      scrollToReviews();
    });
  }

  if (!buildReviewTeaser() && fullReviews) {
    const reviewObserver = new MutationObserver(() => {
      if (buildReviewTeaser()) reviewObserver.disconnect();
    });
    reviewObserver.observe(fullReviews, { childList: true, subtree: true });
    window.setTimeout(() => reviewObserver.disconnect(), 12000);
  }

  if (root.querySelector('[data-enquiry-success]') && dialog?.showModal) {
    dialog.showModal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
